var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.248 415.232h393.216c14.707 0 26.624 11.917 26.624 26.624s-11.917 26.624-26.624 26.624h-393.216c-14.707 0-26.624-11.917-26.624-26.624s11.917-26.624 26.624-26.624zM61.44 437.76c0-243.182 197.138-440.32 440.32-440.32s440.32 197.138 440.32 440.32c0 243.182-197.138 440.32-440.32 440.32s-440.32-197.138-440.32-440.32zM881.592 437.76c0-209.777-170.056-379.832-379.832-379.832s-379.833 170.056-379.833 379.832c0 209.777 170.056 379.833 379.833 379.833s379.832-170.056 379.832-379.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.eb22590f779de9970de18842b0a18565.svg";
export { ForwardRef as ReactComponent };